"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeSelectedListItems = void 0;
var slate_1 = require("slate");
var Utils_1 = require("../Utils");
var List_1 = require("ContentTokens/Models/List");
var lodash_1 = __importDefault(require("lodash"));
var normalizeSelectedListItems = function (editor) {
    if (!editor.selection) {
        return false;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var currBlock = (0, Utils_1.getClosestBlock)(editor, startPoint.path);
    if (!currBlock) {
        return false;
    }
    if (!isNumberedListItem(currBlock[0])) {
        return false;
    }
    var prevBlock = (0, Utils_1.getPrevious)(editor, startPoint.path, Utils_1.isBlockElement);
    var nextBlock = (0, Utils_1.getNext)(editor, startPoint.path, Utils_1.isBlockElement);
    if (prevBlock && isNumberedListItem(prevBlock[0]) && currBlock[0].data.startCounter != undefined) {
        var nextData = lodash_1.default.cloneDeep(currBlock[0].data);
        delete nextData.startCounter;
        slate_1.Transforms.setNodes(editor, { data: nextData }, { at: currBlock[1] });
        return true;
    }
    if (nextBlock && isNumberedListItem(nextBlock[0]) && nextBlock[0].data.startCounter != undefined) {
        var nextData = lodash_1.default.cloneDeep(nextBlock[0].data);
        delete nextData.startCounter;
        slate_1.Transforms.setNodes(editor, { data: nextData }, { at: nextBlock[1] });
        return true;
    }
    return false;
};
exports.normalizeSelectedListItems = normalizeSelectedListItems;
var isNumberedListItem = function (block) {
    return block && block.type === "listItem" && block.data.listType === List_1.ListItemType.Number;
};
